import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import IRMDCreate from './ManufacturingDomestic/Create';


function InspectionCreate() {
  const [mrntype, setmrntype] = useState('');
  const [mrncategory, setmrncategory] = useState('');
  const [mrntypeDisabled, setmrntypeDisabled] = useState(false);
  const [mrncategoryDisabled, setmrncategoryDisabled] = useState(false);

  const handlemrntypeChange = (event) => {
    const selectedmrntype = event.target.value;
    setmrntype(selectedmrntype);
    setmrncategory(''); // Reset PO category when product type changes
    setmrncategoryDisabled(false); // Enable PO category field
    setmrntypeDisabled(true); // Disable product type field

    // Automatically set PO category if Arai Manufacturing is selected
    if (selectedmrntype === 'Manufacturing') {
      setmrncategory('Domestic');
      setmrncategoryDisabled(true); // Disable PO category field
    }
    if (selectedmrntype === 'Pump Spare') {
      setmrncategory('International');
      setmrncategoryDisabled(true); // Disable PO category field
    }
  };

  const handlemrncategoryChange = (event) => {
    setmrncategory(event.target.value);
    setmrncategoryDisabled(true); // Disable PO category field after selection
  };

  const PageDisplay = () => {
    if (mrntype === 'Tubing') {
      if (mrncategory === 'Domestic') {
        // return <TDCreate />;
      } else if (mrncategory === 'International') {
        // return <TICreate />;
      }
    } else if (mrntype === 'Pump Spare') {
      if (mrncategory === 'International') {
        // return <PICreate />;
      }
    } if (mrntype === 'Manufacturing') {
      return <IRMDCreate />;
    }
    return null;
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>ADD INSPECTION REPORT</h6>
          <Link to="/irindex/1">
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Type:</Form.Label>
                <Form.Select
                  onChange={handlemrntypeChange}
                  value={mrntype}
                  disabled={mrntypeDisabled}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>
            {mrntype === 'Manufacturing' && (
              <Col md="6">
                <Form.Group>
                  <Form.Label>PO Category:</Form.Label>
                  <Form.Control value="Domestic" disabled />
                </Form.Group>
              </Col>
            )}
            {PageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default InspectionCreate;

